import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';

const PUBLIC_API_PATTERNS: string[] = [
  '/api/1.0/register/createNewUser',
  '/api/1.0/enum/getStoreTypeAsync',
  '/api/1.0/OTPSender/sendOTPUserAsync',
  '/api/1.0/enum/getRoleInfoAsync',
  '/api/1.0/enum/getLocationAsync',
  '/api/1.0/enum/getCountryInfoAsync',
  '/api/1.0/enum/getTextServiceTypeAsync',
  '/api/1.0/authentication/authVerifyAccountAsync',
  '/api/1.0/authentication/userLogin',
  '/api/sc/1.0/get_company_house',
  '/api/1.0/authentication/userLogoutAsync',
  '/api/1.0/referral/agent/referralCodeValidatorAsync',
];
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const dialog = inject(MatDialog);

  const isPublicApi = PUBLIC_API_PATTERNS.some((pattern) =>
    req.url.includes(pattern),
  );

  let modifiedReq = req;

  if (isPublicApi) {
    modifiedReq = req.clone({
      setHeaders: {
        'Api-Key':
          'R8QyXfU5ZlPt9VJoMwEcN3B7KsHe4a12gDYvIj0nTqHxSbLrOwFkC6MzEpG',
      },
    });
  } else {
    const token = localStorage.getItem('token');
    if (token) {
      modifiedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
  }
  return next(modifiedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('Interceptor caught error:', error);
      console.error('Raw error:', JSON.stringify(error, null, 2));
      return throwError(() => error);
    }),
  );
};
